// Shared display arithmetic for a selected range and payroll source snapshots.
const dayColumns = [
    {key: 'worked', label: 'Дни отработанные'}, {key: 'Д', label: 'Дни дороги (Д)'},
    {key: 'В', label: 'Дни выходных (В)'}, {key: 'О', label: 'Дни отпуска (О)'},
    {key: 'А', label: 'За свой счёт (А)'}, {key: 'До', label: 'Простой по погоде (До)'},
    {key: 'Б', label: 'Больничные (Б)'}, {key: 'Г', label: 'Гособязанность (Г)'}, {key: 'П', label: 'Прогулы (П)'}
];
const normalizeCode = code => String(code).toLocaleUpperCase('ru-RU') === 'ДО' ? 'До' : String(code);
const number = value => String(Number(Number(value).toFixed(3))).replace('.', ',');

function summarizeDays(records) {
    const byDay = new Map();
    records.forEach(record => {
        const value = byDay.get(record.key) || {minutes: 0, codes: new Set(), policy: record.policy || {}};
        value.minutes += Number(record.worked_minutes || 0);
        (record.codes || []).forEach(code => {
            if (code && String(code).toLocaleLowerCase('ru-RU') !== 'дт') value.codes.add(normalizeCode(code));
        });
        byDay.set(record.key, value);
    });
    const totals = Object.fromEntries(dayColumns.map(column => [column.key, 0]));
    let minutes = 0;
    byDay.forEach(day => {
        minutes += day.minutes;
        if (day.minutes > 0) totals.worked += day.minutes >= Number(day.policy.full_day_minimum_minutes || 300)
            ? 1 : Number(day.policy.partial_day_value === undefined ? 0.5 : day.policy.partial_day_value);
        day.codes.forEach(code => { totals[code] = (totals[code] || 0) + 1; });
    });
    return {minutes, totals};
}

function orderedKeys(totals) {
    const known = dayColumns.map(column => column.key);
    return known.concat(Object.keys(totals).filter(key => !known.includes(key)).sort((a, b) => a.localeCompare(b, 'ru')));
}
function formatCipher(totals) {
    if (!totals) return 'Нет данных';
    return orderedKeys(totals).filter(key => totals[key]).map(key => `${number(totals[key])}${key === 'worked' ? '' : key}`).join('+') || '0';
}
module.exports = {dayColumns, normalizeCode, number, summarizeDays, orderedKeys, formatCipher};
